<template>
<div>
  <PageAppBar>{{title}}</PageAppBar>
  <div class="page-content header-clear-small">
    <div v-if="loading" class="text text-center">
      <mushonga></mushonga>
    </div>
    <div v-else>
      <div class="card card-style preload-img card-edit" data-src="images/pictures/27t.jpg" style="height: 250px; background-image: url(&quot;images/pictures/27t.jpg&quot;);">
        <div class="card-center text-center">
          <i class="fa fa-circle-notch fa-5x color-white"></i>
          <h1 class="color-white mt-4">{{ round.project }}</h1>
          <p class="color-white font-12 mt-n2 mb-5 margin-edit">{{ round.details }}</p>
        </div>
        <div class="card-overlay bg-black opacity-80"></div>
      </div>
      <div class="card card-style">
        <div class="content mb-2">
          <h3>Details</h3>
          <p v-if="joined" class="color-highlight font-12 mt-n2 mb-2">{{ message }}</p>
          <p>
            <span>
              <i v-for="contribution in round.my_contributions" :key="contribution.id" class="fa fa-star color-yellow1-dark"></i>
            </span>
          </p>
          <div class="divider mt-2 mb-2"></div>
          <div class="d-flex">
            <div class="pt-1">
              <h5 data-activate="question-1" class="font-600">Contribution Amount: USD {{round.amount}}</h5>
            </div>
          </div>
          <div class="divider mt-2 mb-2"></div>
          <div class="d-flex">
            <div class="pt-1">
              <h5 data-activate="question-2" class="font-600">Duration: {{round.number}}  month (s) </h5>
            </div>
          </div>
          <div class="divider mt-2 mb-2"></div>
          <div class="d-flex">
            <div class="pt-1">
              <h5 data-activate="question-3" class="font-600">Started: {{formatDate(round.created_at)}}</h5>
            </div>
          </div>
          <div v-if="!joined" class="container">
            <div class="col-md-12 text-center">
              <button @click="joinRoundProject(round)" class="btn mb-3 mt-3 btn-success text-uppercase text-white font-900 color">Join Round</button>
            </div>
          </div>
          <div v-else-if="joined" class="container">
            <div class="col-md-12 text-center">
              <router-link :to="'/chat/rounds/'+round.id" class="btn mb-3 mt-3 btn-success text-uppercase text-white font-900 color">Start Chat</router-link>
            </div>
          </div>
          <div v-else-if="loading" class="container">
            <mushonga></mushonga>
          </div>
        </div>
      </div>
    </div>
  </div>
  <FooterBar></FooterBar>
</div>
</template>

<script>
import global from "@/mixins/global";
import PageAppBar from "@/components/PageAppBar";
import FooterBar from "@/components/FooterBar";
import axios from "axios";
export default {
  mixins: [global],
  mounted() {
    this.fetchRoundDetails()
    console.log(this.user)
  },
  name: "SingleRound",
  components: {FooterBar, PageAppBar},
  data(){
    return {
      title: "Round"+this.$route.params.id,
      round:{},
      loading: false,
      joinedCount:0,
    }
  },
  methods: {
    fetchRoundDetails(){
      this.loading = true
      axios.get(this.base_url+"rounds/"+this.$route.params.id, this.requestAuthHeaderToken(localStorage.getItem("token"))).then(response=>{
        this.round = response.data.data
        this.title = this.round.project
        this.loading = false
        
        this.user.rounds.forEach(round => {
          if(this.round.id == round.round.id) { 
            this.joinedCount +=1
             }
          });
          this.joinedCount>0? this.joined = true : this.joined =false
      }).catch(error=>{
        this.error = error
        this.loading = false
      })
    },
  }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Roboto:wght@900&display=swap');
.color{

  border: 1px solid rgba(218, 68,83); 
  background-color:rgba(218, 68,83) !important;
  border-radius: 10px;
  font-family: 'Roboto', sans-serif;
  
}
.card-edit{
  
  margin: 10px 7px 15px;
}
.margin-edit{
  
  margin-left: 8px;
  margin-right: 8px;

}

</style>